import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { buildStyleObj, buildStyles, matchStyle } from 'Components/ComponentLibrary/DesignSystem/utils';
import { fade, darken } from '@material-ui/core/styles/colorManipulator';
import { getBorderRadius } from 'Components/utils';

const ROOT_COLOR_PREFIX = 'rootColor';

export const COLORS = [
  'primaryBlue',
  'accentGreen',
  'orange',
];

const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    ...getBorderRadius(theme.radius.sm, { all: true }),
  },
  ...buildStyles(COLORS.map((color) => {
    return buildStyleObj(color, {
      backgroundColor: fade(theme.palette.facet[color], 0.2),
      color: darken(theme.palette.facet[color], 0.8),
    });
  }), ROOT_COLOR_PREFIX, (config) => {
    return {
      backgroundColor: config.backgroundColor,
    };
  }),
});

const getColor = (status) => {
  // eslint-disable-next-line default-case
  switch (status) {
    case 'proposed':
      return 'accentGreen';
    case 'ready-to-send':
      return 'primaryBlue';
    case 'not-ready-to-send':
      return 'orange';
    default:
      return 'primaryBlue';
  }
};

const StatusChip = ({
  className,
  classes,
}) => {
  const { pageContentResource } = usePageContentContext();
  const color = getColor(pageContentResource.attr('status'));

  return (
    <Typography
      className={classNames(classes.root, className, matchStyle(classes, COLORS, ROOT_COLOR_PREFIX, color))}
      color={color}
    >
      {pageContentResource.selectedOptionPrompt('status')}
    </Typography>
  );
};

StatusChip.defaultProps = {
  className: '',
};

StatusChip.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StatusChip);
